import { AssetFile } from '~generated/types'
import { downloadFromS3, uploadToS3 } from '~lib/s3'
import { downloadFile } from '~lib/utils/files'

export function getFileName(file: AssetFile) {
  return file.name
}

export function getFileUrl(file: AssetFile) {
  return file.url
}

export function handleDownloadFile(url: string, name: string) {
  if (url.includes('blob')) {
    downloadFile({ url, name })
  } else {
    downloadFromS3(url).then((url) => downloadFile({ url, name }))
  }
}

export async function handleUploadFiles(files: File[]): Promise<AssetFile[]> {
  const promises = files.map(async (file) => {
    const url = await uploadToS3(file)

    return {
      url,
      name: file.name,
      format: file.type,
      size: String(file.size),
    }
  })

  return Promise.all(promises).then((res) => {
    return res.map(({ url, name, format, size }) => ({
      url,
      name,
      format,
      size,
    }))
  })
}
